import { render, staticRenderFns } from "./gapFilling copy.vue?vue&type=template&id=22729ee2&scoped=true"
import script from "./gapFilling copy.vue?vue&type=script&lang=js"
export * from "./gapFilling copy.vue?vue&type=script&lang=js"
import style0 from "./gapFilling copy.vue?vue&type=style&index=0&id=22729ee2&prod&lang=scss&scoped=true"
import style1 from "./gapFilling copy.vue?vue&type=style&index=1&id=22729ee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22729ee2",
  null
  
)

export default component.exports